import { API } from '../../config/api';

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';


export const fetchChatDataRequest = () => ({
  type: FETCH_DATA_REQUEST,
});

export const fetchChatDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data,
});

export const fetchChatDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error,
});


export const fetchConversationsMessage = () => {
  return async (dispatch) => {
    dispatch(fetchChatDataRequest());
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API.conversations}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      dispatch(fetchChatDataSuccess(data || []));
    } catch (error) {
      console.log(error)
      dispatch(fetchChatDataFailure(error.message));
    }
  };
};
